import { AuthType, AuthTypeEnum, BaseAuthenticationMethod } from './base-authentication-method';

export class Smstan extends BaseAuthenticationMethod {
    type = 'smstan';
    mobilePhone = '';
    authtype: AuthType = AuthTypeEnum.AFTERVIEW;
}
